
import { useEffect, useState } from "react";
import ModalWrapper from 'components/ModalWrapper'
import { useTranslation } from "react-i18next";
import { BiDetail } from 'react-icons/bi'
import SectionWrapper from "components/wrappers/SectionWrapper";
import Language from "components/Language";
import PropTypes from 'prop-types';

const CategoryDetails = ({ disabled, data }) => {

    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
    }, [isOpen])


    return (
        <>
            <button disabled={!!disabled}
                className={`capitalize focus:outline-none focus:ring-2 focus:ring-offset-2  transition duration-150 ease-in-out 
              rounded  p-2 text-xl ${disabled ? 'bg-gray-200 text-gray-400' : ' text-gray-500 focus:ring-gray-200 hover:bg-gray-200'}`}
                onClick={() => setIsOpen(true)}>
                <BiDetail />
            </button>

            <ModalWrapper
                open={isOpen}
                setOpen={setIsOpen}
            >
                <div className="w-[480px]  lg:w-[720px]">

                    {/* Title */}
                    <SectionWrapper
                        title={t('form.title')}
                    >
                        <div className="border-t  p-2 ">


                            <div className="flex items-baseline my-2 ">
                                <Language _key="fr" showKeyOnly />
                                <span className="mx-2">{data?.title.french}</span>
                            </div>

                            <div className="flex items-baseline my-2 ">
                                <Language _key="ar" showKeyOnly />
                                <span className="mx-2">{data?.title.arabic}</span>
                            </div>

                            <div className="flex items-baseline my-2 ">
                                <Language _key="en" showKeyOnly />
                                <span className="mx-2"> {data?.title.english}</span>
                            </div>

                        </div>
                    </SectionWrapper>


                </div>

            </ModalWrapper>


        </>

    );

}

export default CategoryDetails;

CategoryDetails.propTypes = {
  disabled: PropTypes.bool,
  data: PropTypes.object,
};

